import insuranceCard from "assets/images/insurance-card.svg";
import pharmacy from "assets/images/pharmacy.svg";
import taxReport from "assets/images/tax-report.svg";
import transferIn from "assets/images/transfer-in.svg";
import {useState} from "react";
import {profile as strings} from "strings";

import AccountLink from "components/AccountLink";
import CardLink from "components/CardLink";
import DeleteAccountModal from "components/DeleteAccountModal";
import Divider from "components/Divider";
import PageTitle from "components/PageTitle";

import {useAuthenticatedUser} from "lib/auth";

import styles from "./ProfilePage.module.css";

export default function ProfilePage() {
  const [authenticatedUser] = useAuthenticatedUser();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  return (
    <div className={styles.container}>
      <PageTitle>{authenticatedUser?.data.name || strings.title}</PageTitle>
      <div className={styles.cardLinksContainer}>
        <div className={styles.cardLinks}>
          <CardLink
            className={styles.cardLink}
            cardLabel={strings.pharmacy}
            cardImageLink={pharmacy}
            to="/profile/pharmacy"
          />
          <CardLink
            className={styles.cardLink}
            cardLabel={strings.insurance}
            cardImageLink={insuranceCard}
            to="/profile/insurance"
          />
          <CardLink
            className={styles.cardLink}
            cardLabel={strings.tax}
            cardImageLink={taxReport}
            to="/profile/tax-report"
          />
          <CardLink
            className={styles.cardLink}
            cardLabel={strings.transfer}
            cardImageLink={transferIn}
            to="/profile/transfer-in"
          />
        </div>
      </div>
      <Divider className={styles.lineDivider} />
      <div className={styles.accountText}>{strings.account}</div>
      <div className={styles.accountLinks}>
        <AccountLink
          className={styles.accountLink}
          label={strings.personal}
          to="/profile/account"
        />
        <AccountLink
          className={styles.accountLink}
          label={strings.changePassword}
          to="/profile/change-password"
        />
        <AccountLink
          className={styles.accountLink}
          label={strings.deleteAccount}
          onChange={() => {
            setShowDeleteModal(true);
          }}
        />
        <DeleteAccountModal
          visible={showDeleteModal}
          onClickClose={() => {
            setShowDeleteModal(false);
          }}
        />
      </div>
    </div>
  );
}
